<template>
  <div class="grarantee-form-contanier">
    <Nav applyType="9600"></Nav>
    <Step :arr="arr" class="mb-6"></Step>
    <div>
      <component :is="electronicComponent" ref="form" @changeIndex="changeIndex" @projectInfo="getProjectInfo">
      </component>
    </div>
  </div>
</template>
<script>
import Step from '../../components/CA/Step'
import nav from '../../components/letter_nav/letter.nav'
import { queryOrderDetail, queryOrderByOuterOrderNo } from '@/api/order'
import information from '../../components/guaranteeStepView/information/information.vue'
import project from '../../components/guaranteeStepView/project/project.vue'
import confirmation from '../../components/guaranteeStepView/confirmation/confirmation.vue'
import { mapMutations, LETTER } from '@/store/modules/letter'
import { ORDER_TYPE, checkGuaranteeDraft } from '@/shared/guaranteeDraft'
const components = [information, project, confirmation]

export default {
  components: {
    Nav: nav,
    Information: information,
    Project: project,
    Confirmation: confirmation,
    Step,
  },
  data() {
    return {
      isCQSW: this.$store.state.letter.isCqsw,
      arr: [
        { icon: 1, span: '电子担保保函信息填写', status: 'finish', time: '' },
        { icon: 2, span: '电子担保保函信息确认', status: 'wait', time: '' },
        { icon: 3, span: '签订承诺书', status: 'wait', time: '' },
        { icon: 4, span: '支付', status: 'wait', time: '' },
        { icon: 5, span: '平台审核', status: 'wait', time: '' },
        { icon: 6, span: '平台出函', status: 'wait', time: '' },
      ],
      operationIndex: 0,
    }
  },
  async created() {
    const { orderID, outerOrderNo } = this.$route.query
    const isNewOrder = !orderID
    if (isNewOrder) {
      const handled = await checkGuaranteeDraft(this, ORDER_TYPE.ELECTRONIC_9600, {
        restore: (draft) => {
          // 继续申请 —— 从草稿恢复，不弹自动填充
          if (draft.formData) {
            const savedStep = typeof draft.step === 'string' ? parseInt(draft.step, 10) : draft.step
            this.operationIndex = Number.isNaN(savedStep) ? 0 : savedStep
            this.clear()
            this.guarantee(draft.formData)
            this.$nextTick(() => {
              if (this.$refs.form && typeof this.$refs.form.init === 'function') {
                this.$refs.form.init(draft.formData)
              }
            })
          }
        },
        skipRestore: () => {
          // 重新申请 —— 清 Redis + Vuex + 强制当前子组件清空表单
          this.clear()
          // 关键：checkGuaranteeDraft 是异步弹窗，子组件已在 created→mount 之间
          // 用旧 formStorage 初始化过 this.form 了，必须显式调 init({}) 覆盖
          this.$nextTick(() => {
            if (this.$refs.form && typeof this.$refs.form.init === 'function') {
              this.$refs.form.init({})
            }
          })
          this.doInit(orderID, outerOrderNo)
        },
      })
      // 没有缓存（checkGuaranteeDraft 返回 false），直接走正常初始化
      if (!handled) {
        this.doInit(orderID, outerOrderNo)
      }
    } else {
      this.doInit(orderID, outerOrderNo)
    }
  },
  methods: {
    ...mapMutations({
      guarantee: LETTER.GUARANTEE,
      clear: LETTER.CLEAR,
      clearApi: LETTER.CLEAR_API
    }),
    doInit(orderID, outerOrderNo) {
      const triggerAutoFill = () => {
        this.$nextTick(() => {
          if (this.$refs.form && typeof this.$refs.form.tryAutoFill === 'function') {
            this.$refs.form.tryAutoFill()
          }
        })
      }
      if (orderID) {
        this.getDataDetail(orderID).then((data) => {
          this.clear()
          this.guarantee(data)
          this.$refs.form.init(data)
          triggerAutoFill()
        })
      } else if (outerOrderNo) {
        queryOrderByOuterOrderNo(outerOrderNo).then((v) => {
          if (v.data) {
            if (v.data.orderId) {
              this.$router.replace({
                path: this.$route.path,
                query: {
                  ...this.$route.query,
                  orderID: v.data.orderId
                }
              })
            }

            this.clear()
            v.data.model.apiId = v.data.apiCode
            this.guarantee(v.data.model)
            this.$refs.form.init(v.data.model)
            triggerAutoFill()
          }
        })
      } else {
        this.clearApi()
        triggerAutoFill()
      }
    },
    getDataDetail(orderID) {
      return queryOrderDetail(orderID).then((v) => {
        return v.data
      })
    },
    changeIndex(index) {
      this.operationIndex = index || 0
    },
    getProjectInfo(row) {
      console.log(row)
    }
  },
  computed: {
    index() {
      return this.operationIndex
    },
    electronicComponent() {
      return components[this.index]
    },
    isCqsw() {
      return this.$store.state.letter.isCqsw
    },
  },
}
</script>
